// Shared categorical palette for LoF/CoF setup. A cool BLUE family tuned to the
// app's system blue — categories differ by shade, never by hue, so the setup
// reads as one calm palette (no green/rose/amber competing with the blue) and
// setup weights never look like risk-grade colours.
export const CATEGORY_PALETTE = [
	'#3b8fd4',
	'#3560c9',
	'#8aa4f0',
	'#22407a',
	'#6d90e6',
	'#a9bef4',
];

// The single shared accent used across the redesigned category UI (border,
// weight sliders, radio "checked" colour) — every category splits one 100%
// budget, so they read as one pool rather than each getting its own colour.
export const CATEGORY_ACCENT = CATEGORY_PALETTE[0];

export const categoryColor = (index: number): string => {
	const normalized = Number.isFinite(index) ? Math.trunc(index) : 0;
	return CATEGORY_PALETTE[
		((normalized % CATEGORY_PALETTE.length) + CATEGORY_PALETTE.length) %
			CATEGORY_PALETTE.length
	];
};

// A shade of a category's colour for one of its components (lighter as the
// index grows), so a component reads as "within this category" wherever its
// weight is shown.
export function componentShade(
	categoryIndex: number,
	compIndex: number,
	count: number,
): string {
	const hex = categoryColor(categoryIndex);
	// Very light tint of the category colour (soft fill), with a touch of
	// variation per component so segments stay distinct.
	const amt = 0.45 + (count > 1 ? (compIndex / count) * 0.12 : 0);
	const n = Number.parseInt(hex.slice(1), 16);
	const r = n >> 16;
	const g = (n >> 8) & 255;
	const b = n & 255;
	const mix = (c: number) => Math.round(c + (255 - c) * amt);
	return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
}
